export default __webpack_public_path__ + "static/media/moon.87ef3bbc.svg";